
import React from "react";
import { Navigate } from "react-router-dom";
import useUser from "../hooks/useUser";

export default function RutaProtegida({
  children,
  areasPermitidas = [1],
}) {
  const user = useUser();

  // VALIDAR USUARIO AUTENTICADO
  if (!user?.codigo_usuario) {
    return <Navigate to="/login" replace />;
  }

  // NORMALIZAR ID DE ÁREA
  const idArea = Number(user.id_area);

  // VALIDAR PERMISOS SEGÚN RUTA
  if (!areasPermitidas.includes(idArea)) {
    return (
      <Navigate
        to="/acceso-denegado"
        replace
      />
    );
  }

  return children;
}
